import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentPending from "@/pages/PaymentPending";
import PaymentFailure from "@/pages/PaymentFailure";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/pending" element={<PaymentPending />} />
          <Route path="/payment/failure" element={<PaymentFailure />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
